
<div class="layout-home" *ngIf="!isLoggedIn">
  <router-outlet></router-outlet>
</div>


<div class="container" *ngIf="isLoggedIn" id="fullContent">
  <page-header></page-header>
  <div class="row">
    <div class="col-xs-3 col-lg-2 hidden-xs hidden-sm"><page-sidebar-menu></page-sidebar-menu></div>
    <div [class]="showSchedule ? 'col-xs-12 col-md-6 col-lg-8' : 'col-xs-12 col-md-9 col-lg-10'"><mat-card class="root-content"><router-outlet (activate)="onActivate($event)"></router-outlet></mat-card></div>
    <div class="col-xs-12 col-md-3 col-lg-2 hidden-xs hidden-sm" *ngIf="showSchedule"><page-sidebar-schedule></page-sidebar-schedule></div>
  </div>
  <mat-icon (click)="backToTop()" class="bt-back-top" *ngIf="showBackTop">arrow_circle_up</mat-icon>
</div>

<!-- 
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
-->